import { Chip, alpha } from "@mui/material";

import { RUN_STATE_TREATMENTS } from "../../runStateTreatment";
import { RUN_STATE_LABELS, type RunStateKey } from "../../runStates";

import type { ChipProps } from "@mui/material";

interface Props {
  state: RunStateKey;
  size?: ChipProps["size"];
}

/**
 * The Launchpad's status word, rendered once so the four states cannot pick up
 * per-screen spellings or colours.
 *
 * A tinted pill with no icon. The state cards carry the icon instead; in a
 * section header the word sits among counts, where a glyph per row is noise
 * and the extra width wraps the narrow General RFP Data column.
 */
const RunStateChip = ({ state, size = "small" }: Props): React.JSX.Element => {
  const { chipColor } = RUN_STATE_TREATMENTS[state];

  return (
    <Chip
      // A span, so the chip can sit inside a disclosure button, which takes
      // inline content only.
      component="span"
      size={size}
      color={chipColor}
      variant="outlined"
      label={RUN_STATE_LABELS[state]}
      sx={
        chipColor && chipColor !== "default"
          ? {
              // No design-system chip variant carries a status tint yet.
              backgroundColor: (theme) =>
                alpha(theme.palette[chipColor].main, 0.08),
            }
          : undefined
      }
    />
  );
};

export { RunStateChip };
export type { Props as RunStateChipProps };
